import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import languageConfig from "../config/languages.json";
import resources from "./index";

if (languageConfig.languageSelectionEnabled) {
  i18next.use(LanguageDetector);
}

i18next.use(initReactI18next).init({
  resources,
  lng: languageConfig.languageSelectionEnabled ? undefined : "en",
  supportedLngs: languageConfig.languageSelectionEnabled ? ["en", "es"] : ["en"],
  fallbackLng: "en",
  debug: import.meta.env.VITE_I18N_DEBUG === "true",
  interpolation: {
    escapeValue: false,
  },
});

export default i18next;
